export const WAITER_PERMISSION_CONFIG = [
  {
    key: "takeOrders",
    label: "Tomar pedidos",
    description: "Permite abrir mesa y cargar pedidos nuevos.",
    dbColumn: "waiter_can_take_orders",
    branchPermissionKey: "waiterCanTakeOrders",
  },
  {
    key: "modifyOrders",
    label: "Modificar pedidos",
    description: "Permite editar cantidades, sumar platos y guardar cambios.",
    dbColumn: "waiter_can_modify_orders",
    branchPermissionKey: "waiterCanModifyOrders",
  },
  {
    key: "cancelOrders",
    label: "Cancelar pedidos",
    description: "Permite anular pedidos cargados desde el panel del mozo.",
    dbColumn: "waiter_can_cancel_orders",
    branchPermissionKey: "waiterCanCancelOrders",
  },
  {
    key: "chargeOrders",
    label: "Cobrar",
    description: "Reserva el permiso para registrar cobros desde flujos del mozo.",
    dbColumn: "waiter_can_charge_orders",
    branchPermissionKey: "waiterCanChargeOrders",
  },
  {
    key: "refundOrders",
    label: "Devolver",
    description: "Reserva el permiso para devoluciones o anulaciones de cobro.",
    dbColumn: "waiter_can_refund_orders",
    branchPermissionKey: "waiterCanRefundOrders",
  },
];

export const DEFAULT_WAITER_PERMISSIONS = {
  takeOrders: true,
  modifyOrders: true,
  cancelOrders: true,
  chargeOrders: false,
  refundOrders: false,
};

export const normalizeWaiterPermissions = (input = {}, fallback = DEFAULT_WAITER_PERMISSIONS) =>
  WAITER_PERMISSION_CONFIG.reduce((acc, permission) => {
    const fallbackValue = Boolean(fallback?.[permission.key]);
    acc[permission.key] =
      input?.[permission.key] === undefined
        ? fallbackValue
        : Boolean(input[permission.key]);
    return acc;
  }, {});

export const mapWaiterPermissionsToDb = (input = {}, fallback = DEFAULT_WAITER_PERMISSIONS) => {
  const normalized = normalizeWaiterPermissions(input, fallback);

  return WAITER_PERMISSION_CONFIG.reduce((acc, permission) => {
    acc[permission.dbColumn] = Boolean(normalized[permission.key]);
    return acc;
  }, {});
};

export const mapWaiterPermissionsFromDb = (
  row = {},
  fallback = DEFAULT_WAITER_PERMISSIONS
) =>
  WAITER_PERMISSION_CONFIG.reduce((acc, permission) => {
    const rowValue = row?.[permission.dbColumn];
    acc[permission.key] =
      rowValue === undefined ? Boolean(fallback?.[permission.key]) : rowValue === true;
    return acc;
  }, {});

export const mapWaiterPermissionsToBranchPermissions = (
  input = {},
  fallback = DEFAULT_WAITER_PERMISSIONS
) => {
  const normalized = normalizeWaiterPermissions(input, fallback);

  return WAITER_PERMISSION_CONFIG.reduce((acc, permission) => {
    acc[permission.branchPermissionKey] = Boolean(normalized[permission.key]);
    return acc;
  }, {});
};

export const mapWaiterPermissionsFromBranchPermissions = (
  permissions = {},
  fallback = DEFAULT_WAITER_PERMISSIONS
) =>
  WAITER_PERMISSION_CONFIG.reduce((acc, permission) => {
    const sourceValue = permissions?.[permission.branchPermissionKey];
    acc[permission.key] =
      sourceValue === undefined ? Boolean(fallback?.[permission.key]) : sourceValue === true;
    return acc;
  }, {});
